var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Task\n  "),_c('vue-apex-charts',{attrs:{"type":"pie","height":"350","options":_vm.pieChart.chartOptions,"series":_vm.pieChart.series}}),_vm._l((_vm.tasks),function(task){return _c('li',{key:task.id},[_vm._v("\n    "+_vm._s(task.title)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }